import React from "react";
import { FooterStyles } from "./Styles";
import { getMeaning } from "../../utils/localization";
import logo from "../../assets/logo/AcrossLogoTwo.png";
import { Box, Typography, Link } from "@mui/material";
import { Facebook, LinkedIn, Instagram, X } from "@mui/icons-material";
import GlobalScrollCard from "../../components/GlobalScrollCard";

const Footer = () => {
  return (
    <Box sx={FooterStyles.footerContainer}>
      <Box sx={FooterStyles.footerTop}>
        <Box sx={FooterStyles.logoContainer}>
          <img
            src={logo}
            alt="Company Logo"
            style={{ width: "100%", maxWidth: "300px" }}
          />
        </Box>

        <Box sx={FooterStyles.companyDescription}>
          <Typography
            variant="body1"
            style={{ fontFamily: '"Poppins", serif', fontSize: "0.9rem" }}
          >
            {getMeaning("FOTR.ABOUTAA")}
          </Typography>
        </Box>
      </Box>

      <Box sx={FooterStyles.centerSection}>
        <Box sx={FooterStyles.companyLinks}>
          <Typography
            // variant="h6"
            sx={{
              fontWeight: "bold",
              marginBottom: "10px",
              textDecorationLine: "underline",
              fontSize: "14px",
            }}
          >
            {getMeaning("FOTR.ORCMPNY")}
          </Typography>
          {[
            getMeaning("FOTR.ABTS"),
            getMeaning("FOTR.BLGS"),
            getMeaning("FOTR.CRER"),
            getMeaning("FOTR.PRIVCYPLCY"),
            getMeaning("FOTR.TNC"),
            getMeaning("FOTR.JOINORNTWRK"),
            getMeaning("FOTR.FAQ"),
          ].map((item, index) => {
            let href = `/${item.toLowerCase().replace(/\s+/g, "-")}`;
            let isPdf = false;

            // Customize these values if needed based on the actual `getMeaning` return
            if (item === getMeaning("FOTR.PRIVCYPLCY")) {
              href = "/pdf/PrivacyPolicy.pdf";
              isPdf = true;
            }

            if (item === getMeaning("FOTR.TNC")) {
              href = "/pdf/TermsAndConditions.pdf";
              isPdf = true;
            }
            return (
              <Typography key={index}>
                <Link
                  href={href}
                  target={isPdf ? "_blank" : "_self"}
                  rel={isPdf ? "noopener noreferrer" : undefined}
                  sx={FooterStyles.link}
                >
                  {item}
                </Link>
              </Typography>
            );
          })}
        </Box>

        <Box mt={-2} sx={FooterStyles.companyLinks}>
          <Typography
            // variant="h6"
            sx={{
              fontWeight: "bold",
              marginTop: "15px",
              textDecorationLine: "underline",
              fontSize: "14px",
            }}
          >
            {getMeaning("FOTR.PRDCTS")}
          </Typography>
          {[
            getMeaning("FOTR.TRVLASISTNC"),
            getMeaning("FOTR.AUTOASISTNCE"),
            getMeaning("FOTR.GDGTPRTCTN"),
            getMeaning("FOTR.HMEASISTNCE"),
            getMeaning("FOTR.INCMPROTCT"),
            getMeaning("FOTR.TRVELANDMDCL"),
            getMeaning("FOTR.CYBRSCURITY"),
          ].map((item, index) => (
            <Typography key={index}>
              <Link
                href={`/${item.toLowerCase().replace(/\s+/g, "-")}`}
                sx={FooterStyles.link}
              >
                {item}
              </Link>
            </Typography>
          ))}
        </Box>

        <Box sx={FooterStyles.contactSection}>
          <Typography
            // variant="h6"
            sx={FooterStyles.title}
            style={{
              fontFamily: '"Poppins", serif',
              textDecorationLine: "underline",
              fontSize: "14px",
            }}
          >
            {getMeaning("FOTR.CNCTUS")}
          </Typography>

          <Typography sx={FooterStyles.contactText}>
            <strong
              style={{ fontFamily: '"Poppins", serif', fontSize: "0.8rem" }}
            >
              {getMeaning("FOTR.EMLUS1")}
            </strong>{" "}
            <Link href="mailto:contact@acrossassist.com" sx={FooterStyles.link}>
              {getMeaning("FOTR.EMLUS2")}
            </Link>
          </Typography>

          <Typography sx={FooterStyles.contactText}>
            <strong
              style={{ fontFamily: '"Poppins", serif', fontSize: "0.8rem" }}
            >
              {getMeaning("FOTR.REACHUSAT1")}
            </strong>{" "}
            <Link
              href="https://www.google.com/maps/search/?api=1&query=Company+Address"
              target="_blank"
              sx={FooterStyles.link}
            >
              {getMeaning("FOTR.REACHUS1")} {getMeaning("FOTR.REACHUS2")}{" "}
              {getMeaning("FOTR.REACHUS3")}
            </Link>
          </Typography>

          <Typography mb={2} sx={FooterStyles.contactText}>
            <strong
              style={{ fontFamily: '"Poppins", serif', fontSize: "0.8rem" }}
            >
              {getMeaning("FOTR.CALLUS1")}
            </strong>{" "}
            <Link href="tel:+91-120-450-1401" sx={FooterStyles.link}>
              {getMeaning("FOTR.CALLUS2")}
            </Link>
          </Typography>

          <Typography sx={FooterStyles.contactText}>
            <strong
              style={{ fontFamily: '"Poppins", serif', fontSize: "0.8rem" }}
            >
              {getMeaning("FOTR.FOLLOWUS1")}
            </strong>
            <Link
              href="https://www.facebook.com/AcrossAssistIndia"
              target="_blank"
              sx={FooterStyles.socialIcons}
            >
              <Facebook />
            </Link>

            <Link
              href="https://x.com/AcrossAssist_"
              target="_blank"
              sx={FooterStyles.socialIcons}
            >
              <X />
            </Link>

            <Link
              href="https://www.linkedin.com/company/acrossassist/"
              target="_blank"
              sx={FooterStyles.socialIcons}
            >
              <LinkedIn />
            </Link>

            <Link
              href="https://www.instagram.com/acrossassist/?next=%2F"
              target="_blank"
              sx={FooterStyles.socialIcons}
            >
              <Instagram />
            </Link>
          </Typography>
        </Box>
      </Box>

      <Box>
        <GlobalScrollCard />
      </Box>

      <Box sx={FooterStyles.copyrightContainer}>
        <Box textAlign="center">
          <Typography style={FooterStyles.copyrightText}>
            {getMeaning("FOTR.CPYRYT")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
// {
//   [
//     getMeaning("FOTR.ABTS"),
//     getMeaning("FOTR.BLGS"),
//     getMeaning("FOTR.CRER"),
//     getMeaning("FOTR.PRIVCYPLCY"),
//     getMeaning("FOTR.TNC"),
//     getMeaning("FOTR.JOINORNTWRK"),
//     getMeaning("FOTR.FAQ"),
//   ].map((item, index) => {
//     let href = `/${item.toLowerCase().replace(/\s+/g, "-")}`;
//     let isPdf = false;

//     // Customize these values if needed based on the actual `getMeaning` return
//     if (item === getMeaning("FOTR.PRIVCYPLCY")) {
//       href = "/privacy-policy.pdf";
//       isPdf = true;
//     }

//     if (item === getMeaning("FOTR.TNC")) {
//       href = "/terms-and-conditions.pdf";
//       isPdf = true;
//     }

//     return (
//       <Typography key={index}>
//         <Link
//           href={href}
//           target={isPdf ? "_blank" : "_self"}
//           rel={isPdf ? "noopener noreferrer" : undefined}
//           sx={FooterStyles.link}
//         >
//           {item}
//         </Link>
//       </Typography>
//     );
//   });
// }
